import { theme, styled } from 'ui/theme';

import ButtonBase from './ButtonBase';

const ButtonIcon = styled(ButtonBase)`
  color: ${theme.colors.action.navigation.standard.highlight};
  display: flex;
  height: initial;

  /* Inner Space Size */
  &[data-size='small'],
  &[data-size='large'] {
    height: initial;
  }
`;

export default ButtonIcon;
